import { gql } from '@apollo/client'

export const OPERATION_FIND_MESSAGE = gql`
  query FindMessage($sf_id: String!) {
    message: findMessage(sf_id: $sf_id) {
      id
      title
      content
      site_sf_id
      enable
    }
  }
`

export const OPERATION_FIND_ROOMS = gql`
  query GetRooms(
    $sf_ids: String!
    $verbatim: String
    $withTV: Boolean
    $withChromecast: Boolean
    $onlyUnreachable: Boolean
  ) {
    rooms: findRooms(
      sf_ids: $sf_ids
      verbatim: $verbatim
      withTV: $withTV
      withChromecast: $withChromecast
      onlyUnreachable: $onlyUnreachable
    ) {
      id
      name
      hotspot_id
      wifi_psk
      site_sf_id
      site_name
      ssid_name
      tvs_pincode
      message {
        id
        title
        content
        enable
        site_sf_id
      }
      devices {
        ... on TV {
          uuid
          label
          model
          manufacturer  
          serial
          mac
          psk  
          is_provisioning
          is_reachable
          kind
          wired
        }
        ... on Chromecast {
          uuid
          label
          model
          manufacturer  
          serial
          mac
          psk  
          is_provisioning
          is_reachable
          kind
          standalone
        }
      }
    }
  }
`
